import { seoSections } from '@/mocks/categories';

export default function SafetySection() {
  const { safety } = seoSections;

  return (
    <section id="bezpieczenstwo" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-sm font-semibold text-accent-600 uppercase tracking-wider mb-3">Bezpieczeństwo</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              {safety.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {safety.intro}
            </p>
            <div className="space-y-3">
              {safety.tips.map((tip, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-3 bg-background-50 rounded-lg border border-background-200"
                >
                  <div className="w-5 h-5 flex items-center justify-center bg-accent-100 rounded-full mt-0.5 flex-shrink-0">
                    <i className="ri-shield-check-line text-xs text-accent-600"></i>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{tip}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden animate-fade-in-up">
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20wrapped%20kraft%20paper%20parcels%20with%20twine%20string%20tied%20in%20bows%20on%20marble%20countertop%20elegant%20unboxing%20experience%20ecommerce%20packaging%20photography%20with%20warm%20morning%20light%20streaming%20through%20window%20trustworthy%20shopping%20concept%20premium%20presentation%20lifestyle%20product%20photography%20with%20soft%20natural%20shadows%20and%20serene%20atmosphere&width=800&height=700&seq=kakobuy-safety-img&orientation=portrait"
              alt="Bezpieczeństwo Kakobuy Spreadsheet"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}